import request from '../utils/require'

//短信页面随机码
export function loginIndex(){
  return request({
    url:'/Login/loginIndex',
    method:'GET'
  })
}

//短信
export function sendMsg(payload){
  return request({
    url:'/Login/sendMsg',
    method:'POST',
    data:{
      content:JSON.stringify({
        area_code:payload.payload.area_code,
        tel:payload.payload.tel,
        check_code:payload.check_code
      })
    }
  })
}

//注册
export function register(payload){
    return request({
        url:'/Login/register',
        method:'POST',
        data:{
            content:JSON.stringify({
                tel:payload.payload.tel,
                code:payload.check_code,
                pwd:payload.payload.pwd,
                user_name:payload.payload.nick_name,
            })
        }
    })
}

//国家列表
export function getCity(){
  return request({
    url:'/Login/getCity',
    method:'GET'
  })
}

// 扫码登录后的code提交给后台
export function commit_code(payload){
  return request({
    url:'/Login/get_accesstoken?code='+payload,
    method:'GET'
  })
}

// 获取新闻滚动
export function get_roll_news_list(payload){
    return request({
        url:'/info_manage/get_roll_news_list',
        method:'POST',
        data:payload
    })
}


// 获取首页banner
export function get_all_banner(){
    return request({
        url:'/info_manage/get_all_banner',
        method:'GET'
    })
}

// 获取新闻
export function get_news_list(payload){
    return request({
        url:'/info_manage/get_news_list',
        method:'POST',
        data:payload
    })
}

// 获取公共部分
export function get_all_website_desc_info(){
    return request({
        url:'/info_manage/get_all_website_desc_info',
        method:'GET'
    })
}

// 获取地址栏参数
export function UrlSearch(){
  var name, value;
  var str = location.href; //取得整个地址栏
  var num = str.indexOf("?");
  str = str.substr(num + 1); //取得所有参数   stringvar.substr(start [, length ]

  var arr = str.split("&"); //各个参数放到数组里
  for (var i = 0; i < arr.length; i++) {
    num = arr[i].indexOf("=");
    if (num > 0) {
      name = arr[i].substring(0, num);
      value = arr[i].substr(num + 1);
      this[name] = value;
    }
  }
}

//扫一扫微信参数
export function findBillSn(){
  console.log('findBillSn')
  return request({
    method:'GET',
    url:"/Login/get_data"
  })
}

// 判断姓名与证件是否一致
export function check_upload_idcard_name(data){
  return request({
    url:'/user_upload/check_upload_idcard_name',
    method:'post',
    data:data
  })
}


// 判断手机号是否注册过

export function check_phone_uni(data){
  return request({
    url:'/Login/check_phone_uni',
    method:'post',
    data:data
  })
}




// WEBPACK FOOTER //
// ./src/services/selectSide.js